import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.tasks.tasks.daily.facebook_story,
    props.user.user,
    (post, user) => {
        return {
            post,
            invite_url: user.type === "local" ? `https://lucksy.net/?r=${user.referral_code}` : `https://t.me/lucksy_bot?start=${user.referral_code}`
        }
    }
)